import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
    {
        id: "hs-04-h4v0-01",
        name: "PO 01 - H4V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 167, y: 120, width: 456, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 167, y: 452, width: 456, height: 323, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 120, width: 456, height: 324, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 452, width: 456, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-02",
        name: "PO 02 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 80, y: 111, width: 467, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 80, y: 451, width: 467, height: 332, rotation: 0, imageRotation: 0 },
            { id: "3", x: 705, y: 111, width: 467, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 705, y: 451, width: 467, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-03",
        name: "PO 03 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 325, width: 308, height: 244, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 325, width: 308, height: 244, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 325, width: 308, height: 244, rotation: 0, imageRotation: 0 },
            { id: "4", x: 946, y: 325, width: 307, height: 244, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-04",
        name: "PO 04 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 549, width: 308, height: 244, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 549, width: 308, height: 244, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 549, width: 307, height: 244, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 549, width: 307, height: 244, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-05",
        name: "PO 05 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 53, y: 72, width: 522, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 452, width: 522, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 72, width: 522, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 452, width: 522, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-06",
        name: "PO 06 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 60, y: 76, width: 334, height: 243, rotation: 0, imageRotation: 0 },
            { id: "2", x: 60, y: 327, width: 334, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 60, y: 577, width: 334, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 685, y: 266, width: 508, height: 361, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-07",
        name: "PO 07 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 63, y: 204, width: 500, height: 488, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 204, width: 508, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 685, y: 541, width: 251, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 541, width: 251, height: 150, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-08",
        name: "PO 08 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 69, y: 97, width: 315, height: 229, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 334, width: 315, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 570, width: 315, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 392, y: 97, width: 791, height: 702, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-09",
        name: "PO 09 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 121, y: 166, width: 247, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 121, y: 356, width: 247, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 121, y: 547, width: 247, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 375, y: 166, width: 755, height: 563, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-10",
        name: "PO 10 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 32, y: 34, width: 575, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 32, y: 452, width: 575, height: 410, rotation: 0, imageRotation: 0 },
            { id: "3", x: 646, y: 34, width: 575, height: 410, rotation: 0, imageRotation: 0 },
            { id: "4", x: 646, y: 452, width: 575, height: 410, rotation: 0, imageRotation: 0 }
        ],
    }
];